import { Component, Input } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ICellRendererAngularComp } from 'ag-grid-angular';
// import { SubaccountService } from '@services/subaccount.service';

@Component({
  selector: 'wsb-grid-slide-toggle',
  templateUrl: './grid-slide-toggle.component.html',
  styleUrls: ['./grid-slide-toggle.component.scss'],
  standalone: false
})
export class GridSlideToggleComponent implements ICellRendererAngularComp {
  @Input() checked = false;

  onToggleEvent;
  labelOn;
  labelOff;
  hide = false;
  constructor() {}

  public params;

  agInit(params): void {
    this.params = params;
    this.onToggleEvent = params?.toggleEvent ? params.toggleEvent : null;
    this.checked = params?.checked && params.checked instanceof Function ? this.params.checked(params) : false;
    this.labelOn = params.labelOn;
    this.labelOff = params.labelOff;
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params) : false;
  }

  refresh(params: any): boolean {
    return true;
  }

  onChange(event: MatSlideToggleChange) {
    // this.onToggleChange.emit();
    if (this.onToggleEvent) {
      this.onToggleEvent(this.params, event.checked);
    }
  }
}
